import React from "react";
import Page from "../../components/Page";

import CreateEmployeeStepper from "../../components/CreateEmployeeStepper";
import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";

const CreateEmployeePage = () => (
  <Page enableGoBack title="Medewerker toevoegen">
    <CenteredPageContentContainer>
      <PaperContainer title="Medewerker toevoegen">
        <CreateEmployeeStepper />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

export default CreateEmployeePage;



// WEBPACK FOOTER //
// ./src/pages/Employee/CreateEmployeePage.js